import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import db from '@/firebase/init';

const state = () => ({
  soon: {
    tasks: [],
  }
})

const getters = {
  getSoon: (state) => () => {
    return state.soon;
  },

  getSoonTasks: (state) => () => {
    return state.soon.tasks;
  },
}

const actions = {

  fetchSoon(context) {
    let user = firebase.auth().currentUser;
    db.collection('soon').doc(user.uid).get()
      .then((doc) => {
        if (doc.exists) {
          context.commit('setSoon', doc.data());
        } else {
          // No soon document ()
        }
      }).catch((error) => {
        console.log("Error getting soon:", error);
      });
  },

  saveSoon(context) {
    let user = firebase.auth().currentUser;
    let soonDoc = context.getters.getSoon();
    db.collection("soon").doc(user.uid).set(soonDoc)
      .then(() => {
          console.log("soon successfully saved!");
      })
      .catch((error) => {
          console.error("Error writing soon: ", error);
      });
  },

}

const mutations = {

  setSoon(state, soonObject) {
    Vue.set(state, "soon", soonObject);
  },
  editSoon(state, {soonObject, key, value}) {
    Vue.set(soonObject, key, value);
  },

  // tasks
  addTask(state, {soonTasks, position, task}) {
    soonTasks.splice(position, 0, task);
  },
  editTask(state, {task, key, value}) {
    Vue.set(task, key, value);
  },
  removeTask(state, {soonTasks, position}) {
    soonTasks.splice(position, 1);
  },

}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
